var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '../../styled';
const TextButtonWrapper = styled.button `
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  padding: 0;
  outline: none;
  background-color: transparent;
  color: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].textColor]};
  border-bottom-width: 0.0625rem;
  border-bottom-style: ${({ lineStyle }) => lineStyle};
  border-bottom-color: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].underlineColor]};
  svg {
    padding-right: 0.125rem;
    vertical-align: sub;
    fill: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].textColor]};
  }

  &:hover:enabled {
    cursor: pointer;
    color: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].hoverTextColor]};
    border-bottom-width: 0.0625rem;
    border-bottom-style: ${({ lineStyle }) => lineStyle};
    border-bottom-color: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].hoverUnderlineColor]};
    svg {
      fill: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].hoverTextColor]};
    }
  }

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].disabledTextColor]};
    border-bottom-width: 0.0625rem;
    border-bottom-style: ${({ lineStyle }) => lineStyle};
    border-bottom-color: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].disabledUnderlineColor]};
    svg {
      fill: ${({ theme, textButtonKey }) => theme.colors[theme.textButtons.types[textButtonKey].disabledTextColor]};
    }
  }
`;
const textButtonGenerator = (textButtonKey) => (_a) => {
    var { children, disabled, lineStyle = 'solid' } = _a, restProps = __rest(_a, ["children", "disabled", "lineStyle"]);
    return (React.createElement(TextButtonWrapper, Object.assign({ disabled: disabled, textButtonKey: textButtonKey, lineStyle: lineStyle }, restProps), children));
};
export const Primary = textButtonGenerator('primary');
export const Destructive = textButtonGenerator('destructive');
export const Reversed = textButtonGenerator('reversed');
export const Secondary = textButtonGenerator('secondary');
//# sourceMappingURL=index.js.map